import { ContextProvider } from "./context/Context";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import ProtecedRoute from "./ProtecedRoute";
import HomePage from "./Pages/HomePage";
import SignupPage from "./Pages/SignupPage";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import ContestPage from "./Pages/ContestPage";
import { ViewContextProvider } from "./context/ViewContext";
import ShowCaseImageGallery from "./Components/ShowCase/ShowCaseImageGallery";
import Showcase from "./Components/ShowCase/Showcase";
import Error from "./Pages/Error";
import Profile from "./Components/Profile/Profile";
import UploadPageNew from "./Pages/UploadPageNew";
import Help from "./Components/Profile/Help";
import Privacy from "./Components/Profile/Privacy";
import Terms from "./Components/Profile/Terms";
import ChatForHelp from "./Components/HelpButton/ChatForHelp";
import Banner from "./Components/Banner";
import NotificatinPage from "./Pages/NotificatinPage";
import UnAuthorizedUser from "./Components/UnAuthorizedUser/UnAuthorizedUser";
import Layout from "./Layout/Layout";
import PosterCreation from "./Pages/PosterCreationLanding";
import PosterSelected from "./Pages/PosterSelected";
import PosterGenerated from "./Pages/PosterGenerated";
import PosterResults from "./Pages/PosterResults";
import LikedUsers from "./Pages/LikedUsers";
import CampaignsListingPage from "./Pages/CampaignsListingPage";
import EntryDetailPage from "./Components/EntryDetailPage/EntryDetailPage";
import InstallPage from "./Pages/InstallPage/InstallPage";
import HomePageShowcase from "./Pages/HomePageShowcase";
import ProfileDeletePage from "./Pages/ProfileDeletePage";
import ProfileDeleteConfirmPage from "./Pages/ProfileDeleteConfirmPage";
import PrivacyMobile from "./Components/Profile/PrivacyMobile";
import PhotoBoothCreationPage from "./Pages/PhotoBoothCreationPage";
import Rules from "./Components/Profile/Rules";

function App() {
  const organiserId = window.location.pathname.split("/")[1];
  return (
    <div className="App ">
      <div>
        <UserAuthContextProvider>
          <ContextProvider>
            <ViewContextProvider>
              {/* <Banner /> */}
              <ChatForHelp />
              <UnAuthorizedUser />
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<HomePageShowcase />} />
                  <Route path="/campaigns" element={<CampaignsListingPage />} />
                  <Route path="/install" element={<InstallPage />} />
                  <Route
                    path="/:organizerName/:campaignUniqueText"
                    element={<HomePage />}
                  />
                  <Route
                    path="/:organizerName/:campaignUniqueText/signup"
                    element={<SignupPage />}
                  />

                  <Route
                    path="/:organizerName/:campaignUniqueText/:contestId"
                    element={<ContestPage />}
                  />
                  <Route
                    path="/:organizerName/:campaignUniqueText/:contestUniqueText/:index"
                    element={<EntryDetailPage />}
                  />
                  <Route
                    path="/:organizerName/:campaignUniqueText/:contestUniqueText/:videoId/likes"
                    element={<LikedUsers />}
                  />
                  <Route path="/signup" element={<SignupPage />} />
                  <Route
                    path="/:organizerName/:campaignUniqueText/:contestId/participate"
                    element={
                      <ProtecedRoute
                        Component={UploadPageNew}
                        organiserId={organiserId}
                      />
                    }
                  />
                  <Route
                    path="/:organizerName/:campaignUniqueText/:contestId/participate/error"
                    element={<Error />}
                  />
                  <Route
                    path="/profile"
                    element={<ProtecedRoute Component={Profile} />}
                  />
                  <Route
                    path="/profile/delete"
                    element={<ProfileDeletePage />}
                  />
                  <Route
                    path="/profile/delete/confirm"
                    element={<ProfileDeleteConfirmPage />}
                  />
                  <Route
                    path="/:organizerName/:campaignUniqueText/notification"
                    element={<ProtecedRoute Component={NotificatinPage} />}
                  />
                  <Route
                    path="/notification"
                    element={<ProtecedRoute Component={NotificatinPage} />}
                  />
                  <Route path="/profile/help" element={<Help />} />
                  <Route path="/profile/privacy" element={<Privacy />} />
                  <Route path="/profile/tandc" element={<Terms />} />
                  <Route path="/profile/rules" element={<Rules />} />
                  <Route path="/help" element={<Help />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/mobile-privacy" element={<PrivacyMobile />} />
                  <Route path="/tandc" element={<Terms />} />
                  <Route
                    path="/:organizerName/:campaignUniqueText/showcase"
                    // element={<ProtecedRoute Component={ShowCaseImageGallery} />}
                    element={<ProtecedRoute Component={Showcase} />}
                  />
                  <Route
                    path="/photo-booth/:occasion"
                    element={<PhotoBoothCreationPage />}
                  />
                  <Route
                    path="/poster/:occasion"
                    element={<PosterCreation />}
                  />
                  <Route
                    path="/poster/:occasion/upload"
                    element={<ProtecedRoute Component={PosterSelected} />}
                  />
                  <Route
                    path="/poster/:occasion/upload/result"
                    element={<ProtecedRoute Component={PosterResults} />}
                  />
                  <Route
                    path="/poster/:occasion/:uniqueId"
                    element={<PosterGenerated />}
                  />
                  <Route
                    path="/faceswap/:occasion"
                    element={<PosterCreation />}
                  />
                  <Route
                    path="/faceswap/:occasion/upload"
                    element={<ProtecedRoute Component={PosterSelected} />}
                  />
                  <Route
                    path="/faceswap/:occasion/upload/result"
                    element={<ProtecedRoute Component={PosterResults} />}
                  />
                </Route>
              </Routes>
            </ViewContextProvider>
          </ContextProvider>
        </UserAuthContextProvider>
      </div>
    </div>
  );
}

export default App;
